enum QuickAddUIType {
  ItemList = 'ITEM_LIST',
  GICSimulator = 'GIC_SIMULATOR',
  HISASimulator = 'HISA_SIMULATOR',
}

export default QuickAddUIType;
